<template>
  <div class="admin-home container py-4">
    <h1 class="text-center mb-4">Admin Dashboard</h1>

    <!-- Circle (if needed, else remove this block) -->
    <div class="circle mb-4 mx-auto"></div>

    <!-- Modal Trigger -->
    <div class="text-end mb-3">
      <button
        type="button"
        class="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#adminRegisterModal"
      >
        Admin Register
      </button>
    </div>

    <!-- Admin Register Modal -->
    <div
      class="modal fade"
      id="adminRegisterModal"
      tabindex="-1"
      aria-labelledby="adminRegisterModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content p-3">
          <AdminRegister />
        </div>
      </div>
    </div>

    <!-- Admin Profile -->
    <div class="mb-4">
      <AdminProfile />
    </div>

    <!-- Main Grid Layout: Subjects Left, Grades Right -->
    <div class="row g-4">
      <!-- Subjects Left -->
      <div class="col-md-6">
        <div class="card shadow-sm h-100">
          <div class="card-body">
            <h4 class="card-title mb-3">All Subjects</h4>
            <AllSubjects />
          </div>
        </div>
      </div>

      <!-- Grades Right -->
      <div class="col-md-6">
        <div class="card shadow-sm h-100">
          <div class="card-body">
            <h4 class="card-title mb-3">All Grades</h4>
            <AllGrades />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminRegister from '@/components/AdminDashboard/AdminMenu/AdminRegister.vue';
import AdminProfile from '@/components/AdminDashboard/AdminMenu/AdminProfile.vue';
import AllSubjects from '@/components/AdminDashboard/AdminMenu/AllSubjects.vue';
import AllGrades from '@/components/AdminDashboard/AdminMenu/AllGrades.vue';

export default {
  name: 'adminHomeView',
  components: {
    AdminRegister,
    AdminProfile,
    AllSubjects,
    AllGrades,
  },
};
</script>

<style lang="scss" scoped>
.admin-home {
  margin-bottom: 200px;
  max-width: 1200px;

  .circle {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: #007bff;
  }

  .card {
    border-radius: 12px;
    transition: 0.3s ease;
  }

  .card:hover {
    box-shadow: 0 0 12px rgba(0, 0, 0, 0.15);
  }
}
</style>
